// Import Swiper
import Swiper from 'swiper';
// Import Swiper Modules
import { Navigation, Pagination, Controller, Thumbs, Autoplay, FreeMode, Scrollbar, EffectFade } from 'swiper/modules';
// Import Swiper Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/controller';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';

// Make sure Swiper uses the imported modules
Swiper.use([Navigation, Pagination, Controller, Thumbs, Autoplay, FreeMode, Scrollbar, EffectFade]);
window.swiper = Swiper;

/**
 * SwiperManager Class
 *
 * This class is responsible for initializing all Swiper instances
 * on the page.
 */
export class SwiperManager {
    /**
     * Constructor
     */
    constructor() {
        // Initialize the window.swiperInstances array if it doesn't exist
        window.swiperInstances = window.swiperInstances || [];
        // Initialize all Swiper instances on the page
        this.initSwipers();
    }

    /**
     * Initialize all Swiper instances on the page
     */
    initSwipers() {
        // Get all elements with the data-swiper-settings attribute
        document.querySelectorAll('[data-swiper-settings]').forEach((element, index) => {
            try {
                // Parse the JSON string from the data-swiper-settings attribute
                const settings = JSON.parse(element.getAttribute('data-swiper-settings') || '{}');

                // Default settings for all Swipers
                const defaultSettings = {
                    // Add default settings here
                };

                // Merge the default settings with the settings from the data-swiper-settings attribute
                const finalSettings = { ...defaultSettings, ...settings };

                // Generate a name for the Swiper instance
                const swiperName = element.id || `swiperInstance${index}`;

                // Create a new Swiper instance with the final settings
                const swiperInstance = new Swiper(`#${swiperName}`, finalSettings);

                // Add the Swiper instance to the window.swiperInstances array
                window.swiperInstances.push({ name: swiperName, instance: swiperInstance });
            } catch (error) {
                // Log any errors that occur while parsing the JSON string
                console.error('Failed to parse JSON from data-swiper-settings attribute', element.getAttribute('data-swiper-settings'), error);
            }
        });
    }
}

/**
 * Export the Swiper class
 */
export { Swiper };

/**
 * Add an event listener for the DOMContentLoaded event to initialize the Swiper instances
 */
document.addEventListener('DOMContentLoaded', () => new SwiperManager());
